import { Component, HostListener } from '@angular/core';
import { runsInElectron } from '@simpl/element-ng';

import { SettingsService } from './services/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  hasFocus = true;
  @HostListener('window:blur') onBlur = () => this.hasFocus = false;
  @HostListener('window:focus') onFocus = () => this.hasFocus = true;

  selectedValue = this.settingsService.language;

  constructor(private settingsService: SettingsService) {
    if (runsInElectron()) {
      document.documentElement.classList.add('in-electron');
    }
  }
}
